import { track } from '@mc/track-event'

export const trackViewedCategoryDynamicHeader = ({
  headline,
  subheadline,
  categorySlug,
  isDynamicHero,
}: {
  headline: string
  subheadline: string
  categorySlug: string
  isDynamicHero: boolean
}) => {
  track('Viewed Category Dynamic Header', {
    headline,
    subheadline,
    category_slug: categorySlug,
    context: {
      dynamic_header: isDynamicHero,
    },
  })
}
